import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { Nil } from '@pbt/pbt-ui-components'

import { PreferencesChip } from '~/components/dashboard/clients/PreferencesChip'
import DialogNames from '~/constants/DialogNames'
import { getClientPreferencesIsLoading } from '~/store/duck/clientPreferences'
import type { TimetableEvent } from '~/types'
import useDialog from '~/utils/useDialog'

import { useGetClientPreferencesViewData } from '../dashboard/clients/preferences/useGetClientPreferencesViewData'

export interface ClientPreferencesChipProps {
  appointment?: TimetableEvent | Nil
  className?: string
  clientId: string | Nil
  isDisplayWidgetChirp?: boolean
}

function ClientPreferencesChip({
  className,
  clientId,
  appointment,
  isDisplayWidgetChirp,
}: ClientPreferencesChipProps) {
  const { t } = useTranslation('Clients')

  const clientPreferencesIsLoading = useSelector(getClientPreferencesIsLoading)
  const [openClientPreferencesDialog] = useDialog(
    DialogNames.CLIENT_PREFERENCES,
  )

  const onEditPreferences = () => {
    if (!clientPreferencesIsLoading) {
      openClientPreferencesDialog({ clientId })
    }
  }

  const clientPreferences = useGetClientPreferencesViewData(
    clientId,
    appointment,
  )

  return (
    <PreferencesChip
      className={className}
      headerText={t('Clients:CLIENT_PREFERENCES.DISPLAY.HEADER')}
      isDisplayWidgetChirp={isDisplayWidgetChirp}
      preferences={clientPreferences}
      onEditPreferences={onEditPreferences}
    />
  )
}

export { ClientPreferencesChip }
